import type { ContentTags, Difficulty } from '../../services/classService';

/** Tags as one line of text, e.g. "Speaking · English · Grade 9-10 · Easy". */
export const tagSummary = (tags: ContentTags | undefined, difficultyLabel: (d: Difficulty) => string): string =>
  tags
    ? [tags.skill, tags.subject, tags.grade, tags.language, tags.difficulty ? difficultyLabel(tags.difficulty) : null]
        .filter(Boolean)
        .join(' · ')
    : '';
